export default __webpack_public_path__ + "static/media/exam_prep.a8f22338.png";